import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { m, LazyMotion } from 'framer-motion';
const loadFeatures = () => import('~/utils/framerFeatures').then((res) => res.domAnimation);
// import ImageLoader from '~/content/components/ImageLoader';

const Overview = (): JSX.Element => {
	let { t } = useTranslation(['project_maintain-form']);
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
		defaultMatches: true,
	});
	// console.log({ isMd });
	//?  md: 900
	//?  lg: 1200
	//?  xl: 1536

	const containerAnimation = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			// transition: {
			//   staggerChildren: 0.15,
			//   ease: 'easeIn',
			// },
		},
	};

	const itemAnimation = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				duration: 0.3,
				ease: 'linear',
			},
		},
	};

	return (
		<Grid container spacing={4}>
			{/* marginBottom={isMd ? 10 : 5} */}
			<Grid item container spacing={4} justifyContent='space-between'>
				<Grid item container xs={12} md={5} alignItems={'center'}>
					<Box>
						<Typography variant='h5' component='h3' gutterBottom sx={{ fontWeight: 700 }}>
							{t('overview_headline')}
						</Typography>
						<Typography variant='body1' component='p' color='text.secondary'>
							{t('overview_text')}
						</Typography>
					</Box>
				</Grid>

				<Grid
					item
					container
					xs={12}
					md={6}
					alignItems={isMd ? 'center' : 'flex-start'}
					justifyContent={isMd ? 'center' : 'flex-start'}
				>
					<Box>
						<Typography
							component='p'
							variant='caption'
							color='text.secondary'
							fontWeight='bold'
							mb={1}
						>
							{t('overview_bullet_caption')}
						</Typography>
						<LazyMotion strict features={loadFeatures}>
							<m.div
								variants={containerAnimation}
								initial='hidden'
								whileInView={'show'}
								viewport={{
									once: true,
									amount: 0.6,
								}}
							>
								{[
									t('overview_bullet_1'),
									t('overview_bullet_2'),
									t('overview_bullet_3'),
									t('overview_bullet_4'),
									t('overview_bullet_5'),
									t('overview_bullet_6'),
									t('overview_bullet_7'),
									// t('overview_bullet_8'),
									t('overview_bullet_9'),
									t('overview_bullet_10'),
								].map((item, i) => (
									<Grid item xs={12} key={i} component={m.div} variants={itemAnimation}>
										<Box component={ListItem} disableGutters width={'auto'} padding={0}>
											<Box component={ListItemAvatar} minWidth={'auto !important'} marginRight={2}>
												{/* <Box
													component={Avatar}
													bgcolor={theme.palette.secondary.main}
													width={20}
													height={20}
												>
													<svg
														width={18}
														height={18}
														xmlns='http://www.w3.org/2000/svg'
														viewBox='0 0 24 24'
														fill='currentColor'
													>
														<path
															fillRule='evenodd'
															d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z'
															clipRule='evenodd'
														/>
													</svg>
												</Box> */}
												<Box component={Avatar} bgcolor={'transparent'} width={20} height={20}>
													<svg
														width={20}
														height={20}
														xmlns='http://www.w3.org/2000/svg'
														viewBox='0 0 24 24'
														stroke={theme.palette.secondary.main}
														fill={theme.palette.secondary.main}
														// strokeWidth={0.5}
														// color={theme.palette.secondary.main}
														// fill='theme.palette.secondary.main'
														// color='theme.palette.secondary.main'
													>
														<path
															fillRule='evenodd'
															d='M22 5.18 10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45C16.1 2.67 14.13 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72m7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2z'
															clipRule='evenodd'
														/>
													</svg>
												</Box>
											</Box>

											<ListItemText primary={item} />
										</Box>
									</Grid>
								))}
							</m.div>
						</LazyMotion>
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Overview;
